(function ($){
    const handleAudioControls = function () {
        $('audio').each(function () {
            $(this).attr("controlslist", "noplaybackrate nodownload");
        })
    }

    const handleVideoContols = function () {
        if ($('.wp-block-video').length) {
            $('.wp-block-video').each(function (){
                let videoBlock = $(this);
                let videoBlockPlayer = videoBlock.find('video');

                videoBlockPlayer.removeAttr('controls');

                videoBlock.append('<input class="wp-block-video__control-play js-play" type="button">');
                videoBlock.append('<input class="wp-block-video__control-volume js-volume" type="range" min="0" max="100" step="1">');

                let videoBlockPlayButton = videoBlock.find('[type="button"]');
                let videoBlockPlayVolume = videoBlock.find('[type="range"]');

                videoBlockPlayer.on('click', function (e){
                    if(videoBlockPlayer[0].paused) {
                        videoBlockPlayer[0].play();
                        videoBlock.attr('data-status', 'playing');
                    }  else {
                        videoBlockPlayer[0].pause();
                        videoBlock.attr('data-status', '');
                    }
                });

                videoBlockPlayButton.on('click', function (e){
                    if(videoBlockPlayer[0].paused) {
                        videoBlockPlayer[0].play();
                        videoBlock.attr('data-status', 'playing');
                    }  else {
                        videoBlockPlayer[0].pause();
                        videoBlock.attr('data-status', '');
                    }
                });

                videoBlockPlayVolume.on('input change', function (e){
                    videoBlockPlayer[0].volume = $(this).val() / 100;
                })
            });
        }
    }

    $(window).on('load', () => {
        $('html').removeClass('no-js').addClass('js');
        handleAudioControls();
        handleVideoContols();
    });
})(jQuery);
